const Cloud = ({ width }) => {
    return (
        <div className={`cloud-icon ${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 100 100"
                version="1.1"
                viewBox="0 0 100 100"
                xmlSpace="preserve"
            >
                <path
                    d="M43.9 69h-6.5c0-8.6-6.9-15.6-15.5-15.6v-6.5c12.1 0 22 9.9 22 22.1z"
                    className="st0"
                ></path>
                <path
                    d="M77.9 90.5h-56C9.9 90.5.2 80.7.2 68.7c0-11 8.1-20.1 18.6-21.6l.3-6.3c0-17.1 14-31.1 31.1-31.1 17.2 0 31.1 14 31.1 31.1h-6.5c0-13.6-11-24.6-24.6-24.6s-24.6 11-24.6 24.6v.1L25 53.4h-3.1c-8.4 0-15.2 6.9-15.2 15.3S13.5 84 21.9 84h56c8.4 0 15.2-6.9 15.2-15.3s-6.8-15.3-15.2-15.3v-6.5c12 0 21.7 9.8 21.7 21.8s-9.7 21.8-21.7 21.8z"
                    className="st0"
                ></path>
                <path
                    d="M72.1 63l-4.6-4.6c4.7-4.7 7.3-10.9 7.3-17.5h6.5c0 8.3-3.3 16.2-9.2 22.1z"
                    className="st0"
                ></path>
            </svg>
        </div>
    )
}

export default Cloud
